var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPipedrive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7976 6.09598C13.7976 9.12272 11.8433 11.1928 9.04892 11.1928C7.72052 11.1928 6.62565 10.6458 6.2158 9.96218L6.23514 10.6652V15H3.38262V3.79157C3.38262 3.63563 3.34383 3.59599 3.16753 3.59599H2.18994V1.21406H4.57439C5.66836 1.21406 5.94249 2.15132 6.02006 2.56182C6.45028 1.83949 7.58301 1 9.18554 1C11.9412 0.999119 13.7976 3.04896 13.7976 6.09598ZM10.886 6.11532C10.886 4.49448 9.83084 3.38194 8.50155 3.38194C7.40757 3.38194 6.17609 4.10424 6.17609 6.13562C6.17609 7.46313 6.91837 8.84962 8.46273 8.84962C9.59635 8.84873 10.886 8.02867 10.886 6.11532Z",
    fill: "#017737"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPipedrive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Pipedrive.8489c215c9d52b5274e89e413fbbef02.svg";